<template>
  <section class="underwriting-refer">
    <div
      class="table">
      <div class="tr">
        <span>Seating Capacity (Including Driver)</span>
        <span>{{  quoteForm.no_of_seats  }}</span>
      </div>
      <div class="tr th">
        <span>機動車第三者責任險</span>
      </div>
      <template v-if="quoteForm.plil_limit_amt>0">
        <div class="tr ">
          <span>Third Party Liability Insurance</span>
          <span>{{  quoteForm.tppd_limit_amt  }}</span>
        </div>
        <div class="tr">
          <span>附加醫保外醫療費用責任險{{limit_label.name}}</span>
          <span>{{  getOptionName('yesNoOptions',quoteForm.nmc_tppd_limit_amt>0?1:0)  }}</span>
        </div>
      </template>
      <template v-if="quoteForm.plil_limit_amt>0">
        <div class="tr th">
          <span>機動車第三者附加醫保外醫療費用責任險</span>
        </div>
        <div class="tr">
          <span>Vehicle Occupant Liability Insurance</span>
          <span>{{  quoteForm.plil_limit_amt  }}</span>
        </div>

        <div class="tr">
          <span>附加醫保外醫療費用責任險{{plill_limit_label.name}}</span>
          <span>{{  getOptionName('yesNoOptions',quoteForm.nmc_plil_limit_amt>0?1:0)  }}</span>
        </div>
      </template>
      <div class="tr">
        <span>Insurance Options</span>
        <span>{{  getAllOptionName15('ins_opt',quoteForm.ncd_opt)  }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'HzmbUnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    plill_limit_label(){
      let {plil_limit_amt}= this.quoteForm||{}
      let {nmc_plil_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_plil_opt.find(item=>item.condition===plil_limit_amt)||{}
      return result
    },
    limit_label(){
      let {tppd_limit_amt}= this.quoteForm||{}
      let {nmc_tppd_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_tppd_opt.find(item=>item.condition===tppd_limit_amt)||{}
      return result
    },
  },
}
</script>
